import React, { useState, useEffect, useCallback } from 'react';
import { FaClipboardList, FaClock, FaCheckCircle, FaPlay, FaCheck } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import styled from 'styled-components';

const SurveysContainer = styled.div`
  min-height: 100vh;
  background: white;
  padding: 2rem 0;
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 16px;
  color: white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  
  h1 {
    color: white;
    margin: 0;
    font-size: 2.2rem;
    font-weight: 700;
    letter-spacing: -0.5px;
  }
  
  p {
    margin: 0.5rem 0 0 0;
    opacity: 0.9;
    font-size: 1.1rem;
  }
`;

const TabContainer = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 2rem;
  border: 1px solid #e0e0e0;
`;

const TabHeader = styled.div`
  display: flex;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-bottom: 1px solid #e0e0e0;
`;

const TabButton = styled.button`
  flex: 1;
  padding: 1rem 2rem;
  border: none;
  background: ${props => props.$active ? 'rgba(255, 255, 255, 0.2)' : 'transparent'};
  color: white;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  
  &:hover {
    background: ${props => props.$active ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.1)'};
  }
`;

const TabContent = styled.div`
  padding: 1.5rem;
  background: white;
  color: #333;
`;

// Removed filter components as they are no longer needed











const MessageBox = styled.div`
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin: 1rem 0;
  text-align: center;
  font-weight: 500;
  font-size: 0.9rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;















const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #666;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  svg {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #1e3a8a;
    opacity: 0.7;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  
  h3 {
    margin: 0 0 0.5rem 0;
    color: #1e3a8a;
    text-align: center;
  }
  
  p {
    margin: 0;
    font-size: 0.9rem;
    color: #666;
    text-align: center;
  }
`;

const StatusBadge = styled.span`
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

// Removed unused styled components to clean up the code

const SurveyTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
  
  th, td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }
  
  th {
    background: #1e3a8a;
    color: white;
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    vertical-align: middle;
  }
  
  td {
    color: #333;
    vertical-align: middle;
    font-size: 0.9rem;
    padding: 0.75rem 1rem;
  }
  
  tr:hover {
    background: rgba(30, 58, 138, 0.05);
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  /* Mobile Responsive Design */
  // Update the responsive CSS to keep completion date visible
  @media (max-width: 768px) {
    font-size: 0.8rem;
    
    th, td {
      padding: 0.5rem 0.75rem;
    }
    
    // Hide Category column (2nd) instead of Completion Date (4th)
    th:nth-child(2),
    td:nth-child(2) {
      display: none;
    }
  }
  
  @media (max-width: 480px) {
    th, td {
      padding: 0.4rem 0.5rem;
      font-size: 0.75rem;
    }
    
    /* Stack table content vertically on very small screens */
    thead {
      display: none;
    }
    
    tbody, tr, td {
      display: block;
    }
    
    tr {
      background: white;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      margin-bottom: 0.75rem;
      padding: 0.75rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    td {
      border: none;
      padding: 0.25rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      &:before {
        content: attr(data-label);
        font-weight: 600;
        color: #1e3a8a;
        margin-right: 0.5rem;
      }
    }
  }
`;

// Add responsive container for horizontal scroll on medium screens
const TableContainer = styled.div`
  @media (max-width: 768px) and (min-width: 481px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #1e3a8a;
      border-radius: 4px;
    }
  }
`;

// Update ActionButton for better mobile experience
const ActionButton = styled.button`
  background: ${props => {
    if (props.$status === 'available') return 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)';
    if (props.$status === 'completed') return 'linear-gradient(135deg, #10b981 0%, #059669 100%)';
    return 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)';
  }};
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 80px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  svg {
    font-size: 0.85rem;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
    min-width: 70px;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
    width: 100%;
    justify-content: center;
  }
`;

// Add the missing SurveyRow styled component
const SurveyRow = styled.tr`
  cursor: ${props => props.$clickable ? 'pointer' : 'default'};
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(30, 58, 138, 0.05);
  }
  
  @media (max-width: 480px) {
    display: block;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-bottom: 0.75rem;
    padding: 0.75rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;



// Removed LockOverlay - not used in new design

// Cleaned up all unused styled components

const Surveys = () => {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('active'); // 'active' or 'completed'
  const [showMessage, setShowMessage] = useState(false);
  const [messageText, setMessageText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Real survey data from backend
  const [availableSurveys, setAvailableSurveys] = useState([]);
  const [completedSurveys, setCompletedSurveys] = useState([]);
  const [allSurveys, setAllSurveys] = useState([]);
  const [attemptedSurveys, setAttemptedSurveys] = useState(new Set()); // Track attempted link-based surveys
  const [submittingId, setSubmittingId] = useState(null); // Track which survey is being submitted

  // Pagination state for completed surveys
  const [completedPage, setCompletedPage] = useState(1);
  const [completedPagination, setCompletedPagination] = useState({ currentPage: 1, totalPages: 1, totalItems: 0 });

  // Pagination state for available surveys
  const [availablePage, setAvailablePage] = useState(1);
  const [availablePagination, setAvailablePagination] = useState({ currentPage: 1, totalPages: 1, totalItems: 0 });

  const completedList = completedSurveys.filter(response => response.isCompleted || (response.pointsEarned && response.pointsEarned > 0));

  const fetchSurveyData = useCallback(async (isRefresh = false) => {
    try {
      // Only show loading spinner for initial load, not for refreshes
      if (!isRefresh) {
        setLoading(true);
      }
      setError('');

      // Fetch available surveys (with progressive unlock and pagination)
      const availableSurveysResponse = await axios.get(`/surveys?page=${availablePage}&limit=25`, {
        timeout: 10000 // 10 second timeout
      });
      let availableSurveysData = [];
      if (availableSurveysResponse.data.success) {
        availableSurveysData = availableSurveysResponse.data.surveys || [];
        if (availableSurveysResponse.data.pagination) {
          setAvailablePagination({
            currentPage: availableSurveysResponse.data.pagination.page || availablePage,
            totalPages: availableSurveysResponse.data.pagination.totalPages || 1,
            totalItems: availableSurveysResponse.data.pagination.total || 0
          });
        }
      } else {
        throw new Error(availableSurveysResponse.data.message || 'Failed to fetch available surveys');
      }

      // Fetch completed surveys with pagination
      const completedResponse = await axios.get(`/surveys/user/history?page=${completedPage}&limit=25`, {
        timeout: 10000 // 10 second timeout
      });
      let completedSurveysData = [];
      if (completedResponse.data.success) {
        completedSurveysData = completedResponse.data.responses || [];
        // Identify truly completed surveys (points awarded)
        const completedIds = new Set(
          (completedSurveysData || [])
            .filter(r => r.isCompleted)
            .map(r => r.survey?.id || r.surveyId)
        );

        // Remove any link-based surveys from Available that are now completed
        availableSurveysData = (availableSurveysData || []).filter(s => {
          if (s.surveyType === 'link' && completedIds.has(s.id)) {
            return false;
          }
          return true;
        });

        setCompletedSurveys(completedSurveysData);
        if (completedResponse.data.pagination) {
          setCompletedPagination(completedResponse.data.pagination);
        }
      } else {
        throw new Error(completedResponse.data.message || 'Failed to fetch completed surveys');
      }

      const attemptedFromServer = new Set(
        (availableSurveysData || [])
          .filter(survey => survey.surveyType === 'link' && survey.isAttempted)
          .map(survey => survey.id)
      );

      setAvailableSurveys(availableSurveysData);
      setAllSurveys(availableSurveysData);
      setAttemptedSurveys(attemptedFromServer);

      // Log successful data refresh for debugging
      if (isRefresh) {
        console.log('Survey data refreshed successfully:', {
          availableSurveys: availableSurveysData.length,
          completedSurveys: completedSurveysData.length
        });
      }

    } catch (error) {
      console.error('Error fetching survey data:', error);

      // More detailed error handling
      let errorMessage = 'Failed to load surveys. ';
      if (error.code === 'ECONNABORTED') {
        errorMessage += 'Request timed out. Please check your connection.';
      } else if (error.response?.status === 401) {
        errorMessage += 'Please log in again.';
      } else if (error.response?.status >= 500) {
        errorMessage += 'Server error. Please try again later.';
      } else {
        errorMessage += error.response?.data?.message || error.message || 'Unknown error occurred.';
      }

      setError(errorMessage);

      // Ensure arrays are always defined even on error
      setAvailableSurveys([]);
      setCompletedSurveys([]);
      setAllSurveys([]);
    } finally {
      if (!isRefresh) {
        setLoading(false);
      }
    }
  }, []);

  // Fetch survey data from backend - initial load
  useEffect(() => {
    fetchSurveyData();
  }, [fetchSurveyData]);

  // Refresh data when user points change (similar to Dashboard)
  useEffect(() => {
    if (user?.points !== undefined) {
      fetchSurveyData();
    }
  }, [user?.points, fetchSurveyData]);

  // Additional effect to refresh data when user object changes
  useEffect(() => {
    if (user) {
      fetchSurveyData();
    }
  }, [user, fetchSurveyData]);

  // Periodic data refresh to ensure real-time updates
  useEffect(() => {
    // Set up periodic refresh every 30 seconds
    const refreshInterval = setInterval(() => {
      if (user && !loading) {
        fetchSurveyData(true);
        refreshUser();
      }
    }, 30000); // 30 seconds

    // Cleanup interval on component unmount
    return () => {
      clearInterval(refreshInterval);
    };
  }, [user, loading, fetchSurveyData]);

  // Refetch when completed surveys page changes
  useEffect(() => {
    if (user) {
      fetchSurveyData(true);
    }
  }, [completedPage]); // eslint-disable-line react-hooks/exhaustive-deps

  // Refetch when available surveys page changes
  useEffect(() => {
    if (user) {
      fetchSurveyData(true);
    }
  }, [availablePage]); // eslint-disable-line react-hooks/exhaustive-deps

  // Utility function for formatting duration
  const formatDuration = (minutes) => {
    if (minutes < 60) {
      return `${minutes} min`;
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
  };

  // Survey start handler
  const handleSurveyStart = async (survey) => {
    // Check if this is a link-based survey
    if (survey.surveyType === 'link' && survey.externalSurveyUrl) {
      // Don't allow clicking if already attempted or submitting
      if (attemptedSurveys.has(survey.id) || submittingId === survey.id) return;

      setSubmittingId(survey.id);

      try {
        const response = await axios.post(`/surveys/${survey.id}/submit`, {
          responses: { externalSurvey: true },
          timeSpent: 0
        });

        if (response.data.success) {
          setAttemptedSurveys(prev => new Set([...prev, survey.id]));

          const sessionId = response.data.sessionId;
          let targetUrl = survey.externalSurveyUrl;
          if (sessionId) {
            if (/{sid}/i.test(targetUrl)) {
              targetUrl = targetUrl.replace(/{sid}/gi, encodeURIComponent(sessionId));
            } else if (/%7Bsid%7D/i.test(targetUrl)) {
              targetUrl = targetUrl.replace(/%7Bsid%7D/gi, encodeURIComponent(sessionId));
            } else {
              const separator = targetUrl.includes('?') ? '&' : '?';
              targetUrl = `${targetUrl}${separator}sessionId=${encodeURIComponent(sessionId)}`;
            }
          }
          window.open(targetUrl, '_blank');

          // Refresh user data (no points awarded yet for link-based attempt)
          await refreshUser();

          // Show attempt message (no points yet)
          setMessageText(`Survey opened! Complete the survey to earn ${survey.pointsReward} points.`);
          setShowMessage(true);
          setTimeout(() => setShowMessage(false), 5000);
        }
      } catch (error) {
        console.error('Error starting external survey:', error);
        if (error.response?.data?.message === 'Survey already completed') {
          // Already completed, mark as attempted
          setAttemptedSurveys(prev => new Set([...prev, survey.id]));
        }
      } finally {
        setSubmittingId(null);
      }
    } else {
      // Navigate to survey detail page for manual surveys
      navigate(`/surveys/${survey.id}`);
    }
  };

  // Handle URL parameters for survey completion
  useEffect(() => {
    const completed = searchParams.get('completed');
    const refresh = searchParams.get('refresh');

    if (completed === 'true') {
      // Refresh user data to get updated points
      refreshUser();

      // Refresh survey data to get updated lists
      fetchSurveyData();

      // Show success message
      setMessageText('Survey completed successfully! Your points have been updated.');
      setShowMessage(true);

      // Clean up URL parameters
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('completed');
      newSearchParams.delete('refresh');
      setSearchParams(newSearchParams, { replace: true });

      // Clear message after 5 seconds
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } else if (refresh === 'true') {
      // Just refresh data without showing message
      fetchSurveyData();

      // Clean up URL parameters
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('refresh');
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [searchParams, setSearchParams, refreshUser, fetchSurveyData]);

  return (
    <SurveysContainer>
      <ContentWrapper>
        <PageHeader>
          <h1>Survey Dashboard</h1>
          <p>Complete surveys to earn points and unlock rewards</p>
        </PageHeader>

        {/* Success Message */}
        {showMessage && (
          <MessageBox>
            {messageText}
          </MessageBox>
        )}



        {/* Loading State */}
        {loading && (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>Loading surveys...</p>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#e74c3c', background: '#ffeaea', borderRadius: '8px', border: '1px solid #ffcdd2', margin: '1rem 0' }}>
            <p style={{ margin: '0 0 1rem 0', fontWeight: '500' }}>{error}</p>
            <button
              onClick={() => fetchSurveyData(false)}
              style={{
                marginTop: '1rem',
                padding: '0.75rem 1.5rem',
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: '500',
                transition: 'background-color 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.background = '#2563eb'}
              onMouseOut={(e) => e.target.style.background = '#3b82f6'}
            >
              Try Again
            </button>
          </div>
        )}

        {/* Main Content with Tabs */}
        {!loading && !error && (
          <TabContainer>
            <TabHeader>
              <TabButton
                $active={activeTab === 'active'}
                onClick={() => setActiveTab('active')}
              >
                <FaClipboardList />
                Available Surveys ({availableSurveys?.length || 0})
              </TabButton>
              <TabButton
                $active={activeTab === 'completed'}
                onClick={() => setActiveTab('completed')}
              >
                <FaCheckCircle />
                Completed Surveys ({completedList.length || 0})
              </TabButton>
            </TabHeader>

            <TabContent>
              {activeTab === 'active' ? (
                <div>
                  {(availableSurveys?.length || 0) > 0 ? (
                    <TableContainer>
                      <SurveyTable>
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Category</th>
                            <th>Points</th>
                            <th>Time</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {availableSurveys.map((survey, index) => {
                            const isLinkSurvey = survey.surveyType === 'link';
                            const isAttempted = survey.isAttempted || attemptedSurveys.has(survey.id);
                            const isSubmitting = submittingId === survey.id;

                            return (
                              <SurveyRow key={`${survey.id}-${index}`} $clickable={!isAttempted}>
                                <td data-label="Title">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <FaPlay color="#1e3a8a" />
                                    <span>{survey.title}</span>
                                  </div>
                                </td>
                                <td data-label="Category">{survey.category || 'General'}</td>
                                <td data-label="Points">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                    <span>{survey.pointsReward}</span>
                                  </div>
                                </td>
                                <td data-label="Time">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                    <FaClock color="#1e3a8a" />
                                    <span>{formatDuration(survey.estimatedTime)}</span>
                                  </div>
                                </td>
                                <td data-label="Action">
                                  {isLinkSurvey && isAttempted ? (
                                    <ActionButton
                                      $status="completed"
                                      disabled
                                      style={{ opacity: 0.7, cursor: 'not-allowed' }}
                                    >
                                      <FaCheck /> Attempted
                                    </ActionButton>
                                  ) : (
                                    <ActionButton
                                      onClick={() => handleSurveyStart(survey)}
                                      $status="available"
                                      disabled={isSubmitting}
                                      style={isSubmitting ? { opacity: 0.7 } : {}}
                                    >
                                      {isSubmitting ? (
                                        <>⏳ Opening...</>
                                      ) : (
                                        <><FaPlay /> Start</>
                                      )}
                                    </ActionButton>
                                  )}
                                </td>
                              </SurveyRow>
                            );
                          })}
                        </tbody>
                      </SurveyTable>

                      {/* Pagination Controls for Available Surveys */}
                      {availablePagination.totalPages > 1 && (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '1rem',
                          marginTop: '1.5rem',
                          padding: '1rem',
                          borderTop: '1px solid #e0e0e0'
                        }}>
                          <button
                            onClick={() => { setAvailablePage(p => Math.max(1, p - 1)); }}
                            disabled={availablePage === 1}
                            style={{
                              padding: '0.5rem 1rem',
                              background: availablePage === 1 ? '#e5e7eb' : 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                              color: availablePage === 1 ? '#9ca3af' : 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: availablePage === 1 ? 'not-allowed' : 'pointer',
                              fontWeight: 600,
                              fontSize: '0.85rem'
                            }}
                          >
                            ← Previous
                          </button>
                          <span style={{ color: '#64748b', fontSize: '0.9rem' }}>
                            Page {availablePagination.currentPage} of {availablePagination.totalPages}
                          </span>
                          <button
                            onClick={() => { setAvailablePage(p => Math.min(availablePagination.totalPages, p + 1)); }}
                            disabled={availablePage >= availablePagination.totalPages}
                            style={{
                              padding: '0.5rem 1rem',
                              background: availablePage >= availablePagination.totalPages ? '#e5e7eb' : 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                              color: availablePage >= availablePagination.totalPages ? '#9ca3af' : 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: availablePage >= availablePagination.totalPages ? 'not-allowed' : 'pointer',
                              fontWeight: 600,
                              fontSize: '0.85rem'
                            }}
                          >
                            Next →
                          </button>
                        </div>
                      )}
                    </TableContainer>
                  ) : (
                    <EmptyState>
                      <FaClipboardList />
                      <h3>
                        {(completedSurveys?.length || 0) === (allSurveys?.length || 0)
                          ? "All Surveys Completed!"
                          : "No Available Surveys"}
                      </h3>
                      <p>
                        {(completedSurveys?.length || 0) === (allSurveys?.length || 0)
                          ? "You've completed all available surveys. Great job!"
                          : "Complete surveys in order to unlock new ones."}
                      </p>
                    </EmptyState>
                  )}
                </div>
              ) : (
                <div>
                  {(completedList.length || 0) > 0 ? (
                    <>
                      <SurveyTable>
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Category</th>
                            <th>Points Earned</th>
                            <th>Completion Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {completedList.map((response, index) => (
                            <SurveyRow key={`${response.id}-${index}`}>
                                <td data-label="Title">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <FaCheckCircle color="#1e3a8a" />
                                    <span>{response.survey?.title || 'Untitled Survey'}</span>
                                  </div>
                                </td>
                                <td data-label="Category">{response.survey?.category || 'General'}</td>
                                <td data-label="Points Earned">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                    <span>{response.pointsEarned}</span>
                                  </div>
                                </td>
                                <td data-label="Completion Date">
                                  {(() => {
                                    const date = new Date(response.completedAt);
                                    return isNaN(date.getTime()) || !response.completedAt
                                      ? 'Not available'
                                      : date.toLocaleDateString();
                                  })()}
                                </td>
                                <td data-label="Status">
                                  <StatusBadge>
                                    <FaCheck /> Completed
                                  </StatusBadge>
                                </td>
                              </SurveyRow>
                            ))}
                        </tbody>
                      </SurveyTable>

                      {/* Pagination Controls */}
                      {completedPagination.totalPages > 1 && (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '1rem',
                          marginTop: '1.5rem',
                          padding: '1rem',
                          borderTop: '1px solid #e0e0e0'
                        }}>
                          <button
                            onClick={() => { setCompletedPage(p => Math.max(1, p - 1)); }}
                            disabled={completedPage === 1}
                            style={{
                              padding: '0.5rem 1rem',
                              background: completedPage === 1 ? '#e5e7eb' : 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                              color: completedPage === 1 ? '#9ca3af' : 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: completedPage === 1 ? 'not-allowed' : 'pointer',
                              fontWeight: 600,
                              fontSize: '0.85rem'
                            }}
                          >
                            ← Previous
                          </button>
                          <span style={{ color: '#64748b', fontSize: '0.9rem' }}>
                            Page {completedPagination.currentPage} of {completedPagination.totalPages}
                          </span>
                          <button
                            onClick={() => { setCompletedPage(p => Math.min(completedPagination.totalPages, p + 1)); }}
                            disabled={completedPage >= completedPagination.totalPages}
                            style={{
                              padding: '0.5rem 1rem',
                              background: completedPage >= completedPagination.totalPages ? '#e5e7eb' : 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                              color: completedPage >= completedPagination.totalPages ? '#9ca3af' : 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: completedPage >= completedPagination.totalPages ? 'not-allowed' : 'pointer',
                              fontWeight: 600,
                              fontSize: '0.85rem'
                            }}
                          >
                            Next →
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <EmptyState>
                      <FaClipboardList />
                      <h3>No Completed Surveys</h3>
                      <p>Complete some surveys to see them here.</p>
                    </EmptyState>
                  )}
                </div>
              )}
            </TabContent>
          </TabContainer>
        )}
      </ContentWrapper>
    </SurveysContainer>
  );
};

export default Surveys;
